/**
 * 영상 생성 입력 이미지 선택 (BOOTH-103 부스 워터마크).
 *
 * 워터마크 없는 사본(`videoInputDataUrl`) → 변환 결과(`transformedDataUrl`) → 원본(`dataUrl`) 순 우선순위.
 * Veo 에는 워터마크가 없는 사본을 보내야 생성 품질이 유지된다.
 */

export function videoInputFor(
  shot: Pick<
    { videoInputDataUrl: string | null; transformedDataUrl: string | null; dataUrl: string },
    "videoInputDataUrl" | "transformedDataUrl" | "dataUrl"
  >
): string | null {
  return shot.videoInputDataUrl ?? shot.transformedDataUrl ?? shot.dataUrl;
}
